import { render, staticRenderFns } from "./InternalTransferStatus.vue?vue&type=template&id=ac0a1b06&scoped=true&"
import script from "./InternalTransferStatus.vue?vue&type=script&lang=js&"
export * from "./InternalTransferStatus.vue?vue&type=script&lang=js&"
import style0 from "./InternalTransferStatus.vue?vue&type=style&index=0&id=ac0a1b06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0a1b06",
  null
  
)

export default component.exports